import React from 'react';
import { useNavigate } from 'react-router-dom';

function HowItWorks() {
    const navigate = useNavigate();
    const isAuthenticated = !!localStorage.getItem('token'); // Adjust according to your authentication logic

    const handleSignUpRedirect = () => {
        navigate('/signup'); // Always redirect to Sign Up page
    };

    const handleClothesRedirect = () => {
        if (isAuthenticated) {
            navigate('/clothes'); // Redirect to the Clothes section if authenticated
        } else {
            navigate('/signup'); // Redirect to Sign Up page if not authenticated
        }
    };

    const handleOutfitsRedirect = () => {
        if (isAuthenticated) {
            navigate('/outfits'); // Redirect to the Outfits section if authenticated
        } else {
            navigate('/signup'); // Redirect to Sign Up page if not authenticated
        }
    };

    const handleOccasionsRedirect = () => {
        if (isAuthenticated) {
            navigate('/occasions'); // Redirect to the Occasions section if authenticated
        } else {
            navigate('/signup'); // Redirect to Sign Up page if not authenticated
        }
    };

    const handleTravelListsRedirect = () => {
        if (isAuthenticated) {
            navigate('/travellists'); // Redirect to the Travel Lists section if authenticated
        } else {
            navigate('/signup'); // Redirect to Sign Up page if not authenticated
        }
    };

    return (
        <div className="how-it-works">
            <h1><strong>How It Works</strong></h1>
            <p>Our platform is designed to help you manage your wardrobe, create your outfits and categorise them by occasions while also organizing travel lists with ease. Whether you’re prepping for a trip, organizing daily outfits, or planning for a special occasion, Digital Wardrobe simplifies the process. Here’s how it works:</p>

            <h3><strong>1. Create Your Account</strong></h3>
            <p>
                Start by{' '}
                <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={handleSignUpRedirect}
                >
                    signing up
                </span>{' '}
                for a Digital Wardrobe account. With your personal account, you can securely store and manage all of your wardrobe information. Simply click on the "Sign Up" button, fill out your details, and you’re ready to go!
            </p>

            <h3><strong>2. Upload Your Clothing Items</strong></h3>
            <p>
                Begin by uploading your clothing items to your wardrobe through{' '}
                <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={handleClothesRedirect}
                >
                    Clothes
                </span>
                . You can categorize each item by cloth category, color, season, and even more and then upload an image of it. This allows you to easily keep track of what you have in your wardrobe!
            </p>

            <h3><strong>3. Create Your Outfits</strong></h3>
            <p>
                Use Digital Wardrobe’s{' '}
                <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={handleOutfitsRedirect}
                >
                    Outfits
                </span>{' '}
                feature to create stylish looks from the clothing items you’ve added. You can plan daily outfits, special event looks, or even create complete wardrobe capsules for different seasons. This feature helps you visualize your options and make the most of your wardrobe while also saving you time from deciding what to wear and what other clothes to match it with!
            </p>

            <h3><strong>4. Organize by Occasion</strong></h3>
            <p>
                Planning for a specific occasion? Use the{' '}
                <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={handleOccasionsRedirect}
                >
                    Occasions
                </span>{' '}
                feature to organize your wardrobe by events. Whether it’s a wedding, a business meeting, or a night out, you can create outfits that match the occasion and store them for easy reference. This feature helps you stay prepared and stress-free when it comes to deciding what outfit to wear!
            </p>

            <h3><strong>5. Create Travel Lists</strong></h3>
            <p>
                Going on a trip? The{' '}
                <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={handleTravelListsRedirect}
                >
                    Travel Lists
                </span>{' '}
                feature allows you to organize clothing items by trip, packing list, or destination. Specify your departure and return dates, and plan everything you need to take with you. A feature that will definitely help you organize yourself before a trip and remind you what clothing items to bring with you!
            </p>

            <h3><strong>6. Enjoy a More Organized Wardrobe</strong></h3>
            <p>That’s all! Digital Wardrobe streamlines the process of organizing, planning, and managing your wardrobe. Whether you’re preparing for a vacation, planning for the week ahead, or creating looks for a special event, our platform makes it easy to stay on top of your style!</p>

            <h3><strong>- Get Started Today! -</strong></h3>
            <p>Ready to take control of your wardrobe? Create an account today and start enjoying the benefits of a more organized and stylish life with Digital Wardrobe.</p>
        </div>
    );
}

export default HowItWorks;